"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _MenuStyled = require("./Menu-styled");

var _Menu = require("./Menu");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var MenuItem = function MenuItem(_ref) {
  var children = _ref.children,
      subtitle = _ref.subtitle,
      other = _objectWithoutProperties(_ref, ["children", "subtitle"]);

  var menuContext = (0, _react.useContext)(_Menu.MenuContext);

  var getSubtitle = function getSubtitle(subtitle) {
    if (subtitle) {
      return _react.default.createElement(_MenuStyled.StyledMenuItemSubtitle, null, subtitle);
    }
  };

  return _react.default.createElement(_MenuStyled.StyledMenuItem, _extends({
    extraSmall: menuContext.extraSmall,
    small: menuContext.small,
    large: menuContext.large,
    extraLarge: menuContext.extraLarge
  }, other), _react.default.createElement("span", null, children), getSubtitle(subtitle));
};

MenuItem.propTypes = {
  /** Content of the MenuItem. */
  children: _propTypes.default.node,

  /** A container for content to be displayed right aligned in the MenuItem. */
  subtitle: _propTypes.default.node,

  /** Toggle the disabled state of the MenuItem, results in the item being unselectable and slightly lower opacity */
  disabled: _propTypes.default.bool
};
MenuItem.defaultProps = {};
MenuItem.displayName = 'MenuItem';
var _default = MenuItem;
exports.default = _default;